import { Grid } from '@mui/material'
import useMenu from 'hooks/useMenu'
import { FC } from 'react'
import SearchTypeButtonContainer from 'redux/containers/components/search/SearchTypeButtonContainer'
import selectSearchMenu from 'redux/selectors/selectSearchMenu'

interface Props {
  searchType: string
  searchPhrase: string
}

const FacetsContentSkeleton: FC<Props> = (props) => (
  <div className='ph6'>
    <h2 className='mb7 f4 b black lh-title'>Search type</h2>
    <Grid container className='mb7 w-100'>
      <SearchOptionsSkeleton {...props} />
    </Grid>
  </div>
)

const SearchOptionsSkeleton: FC<Props> = (props) => {
  const searchOptions = useMenu(selectSearchMenu).filter(
    ({ hideOnSearch }) => hideOnSearch !== true
  )

  return (
    <>
      {searchOptions.map(({ title, activeClass, typeName, icon }) => (
        <SearchOptionSkeleton
          key={typeName}
          {...{
            ...props,
            typeName,
            icon,
            title,
            activeClass
          }}
        />
      ))}
    </>
  )
}
interface SearchOptionsProps extends Props {
  typeName?: string
  icon?: string
  title: string
  activeClass?: string
}

const SearchOptionSkeleton: FC<SearchOptionsProps> = ({
  searchType,
  typeName,
  searchPhrase,
  icon,
  title,
  activeClass
}) => {
  const isActive = searchType === typeName

  return (
    <Grid item xs={12} className='mb4'>
      <SearchTypeButtonContainer
        isProxy
        searchTerm={searchPhrase}
        {...{ title, activeClass }}
        selected={isActive}
        searchType={typeName}
        iconName={icon}
      />
    </Grid>
  )
}

export default FacetsContentSkeleton
